<template>
  <div class="flex flex-wrap content-start">
    <div v-for="topic in department_topics"
       @click="handle_topic_link(topic.id)"
       :key="topic.id"
       class="relative cursor-pointer w-5/12 sm:w-48 h-32 mr-4 mb-4 bg-ams-blue flex flex-col items-end">
      <score-bar :id="topic.id" type="topic"></score-bar>
      <span class="absolute bottom-0 text-white py-3 px-2 text-right text-xl" v-html="topic.title"></span>
    </div>
    <pre v-if="debug">
      {{ department_topics }}
    </pre>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import ScoreBar from './score_bar.vue'

export default {
  data() {
    return {
      debug: false
    }
  },
  methods: {
    ...mapMutations(['set_current_topic_id']),
    handle_topic_link( id ) {
      this.set_current_topic_id( id )
      this.$router.push(`/topic/${id}`)
    }
  },
  computed: {
    ...mapGetters(['department_topics', 'topic_quiz_blocks_status'])
  },
  components: {
    ScoreBar
  }
}
</script>